module.exports = __webpack_public_path__ + "img/073670.534695a2.png";